import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import createMiddleware from "redux-saga";
import App from "./App";
import rootReducer from "./store/reducers/index";
import { rootSaga } from "./store/sagas/index";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import TagManager from "react-gtm-module";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import "./index.css";
import "./style.scss";

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN,
	integrations: [new BrowserTracing()],
	tracesSampleRate: process.env.REACT_APP_NODE_ENV === 'production' ? 0.2 : 1.0,
	beforeSend: (event) => {
		if (!["testing", "production"].includes(process.env.REACT_APP_NODE_ENV)) {
			// Don't send events in development
			return null;
		}
		return event;
	},
});

if (process.env.REACT_APP_NODE_ENV === 'production') {
	const tagManagerArgs = {
		gtmId: "GTM-PPQ699M",
	};
	TagManager.initialize(tagManagerArgs);
}
const sagaMiddleware = createMiddleware();
const RootApp = (
	process.env.REACT_APP_NODE_ENV === 'production'
		? <App />
		: <StrictMode><App /></StrictMode>
);

ReactDOM.render(
	<Provider store={createStore(rootReducer, applyMiddleware(sagaMiddleware))}>
		{RootApp}
	</Provider>,
	document.getElementById("root")
);
sagaMiddleware.run(rootSaga);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
serviceWorker.register();
